<template lang="html">
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row 
      style="margin-bottom: -105px;"
    >
      <v-col cols="3">
        <v-autocomplete
          v-model="searchedEmployee"
          :items="employeeNames"
          class="ml-4"
          clearable
          hide-no-data
          hint
          hide-selected
          label="Employees"
          placeholder="Search Employees"
          item-text="name"
          item-value="employee_uid"
          filled
          background-color="white"
          @change="searchEmployeeInChart"
        />
      </v-col>
      <employee-profile-side-bar
        :user="user"
        :user-name="userName"
        :user-pob-id="userPobId"
        :drawer="drawer"
        :employee-uid="employeeUid"
        :department-name="departmentName"
        @changeDrawerStatus="changeStatus($event)"
      />
    </v-row>
    <div id="root" />
  </div> 
</template>

<script>
  const { init, searchEmployee } = require('../../plugins/orgchart/chart')

  export default {
    components: {
      EmployeeProfileSideBar: () => import('@/components/employee/ProfileSideBar'),
    },
    metaInfo () {
      return {
        title: 'Organization Chart',
      }
    },
    data () {
      return {
        isLoading: false,
        departmentList: [],
        employeeNames: [],
        searchedEmployee: '',
        drawer: false,
        user: null,
        userName: '',
        userPobId: '',
        employeeUid: '',
        departmentName: '',
      }
    },
    computed: {

    },
    mounted () {
      window.orgchart = this
      this.isLoading = true
      Promise.all([
        this.$api.departments().list([], true),
        this.$api.reportTo().overview(),
      ])
        .then(([department, res]) => {
          this.departmentList = department.data
          let temp = this.processOrgChartData(res)
          init({ id: '#root', data: { children: this.flatToHierarchy(temp) }, lineType: 'angle' })
          this.setColorsForDepartment()
          this.isLoading = false
        })
    },
    methods: {
      setColorsForDepartment () {
        let count = 0
        let colors = [
          'darkcyan', 'indigo', 'blue', 
          'purple', 'red', 'seagreen', 
          'blueviolet', 'darkgoldenrod', 'darkred',
          'orange',
        ]
        this.departmentList.forEach(function (departmentLists) {
          if (count >= 10) {
            count = 0
          }
          Object.assign(departmentLists, { colors: colors[count] })
          count++
        })
      },
      setDrawerStatus (status) {
        this.$set(this, 'drawer', status)
      },
      show () {
        this.setDrawerStatus(true)
      },
      getUserName (name) {
        this.userName = name
      },
      getUserPlaceOfBirthId (pob) {
        this.userPobId = pob
      },
      getDepartmentList () {
        return this.departmentList
      },
      getEmployee (employee) {
        this.employeeUid = employee.employee_uid
        this.departmentName = employee.departmentName
      },
      changeStatus (status) {
        this.drawer = status
      },
      processOrgChartData (res) {
        let temp = []
        this.employeeNames = []

        res.data.forEach((employee) => {
          this.employeeNames.push({
            employee_uid: employee.employee_uid,
            name: employee.person ? employee.person.name.substring(0, 25) : 'No Person',
          })
          let toAdd = {
            id: employee.employee_uid,
            employee_uid: employee.employee_uid,
            departmentName: employee.department ? employee.department.name : employee.department,
            departmentId: employee.department_id,
            name: employee.person ? employee.person.name : 'No Person',

            person: {
              avatar: employee.avatar_url,
              thumbnail: employee.thumbnail_url,
              id: employee.person_uid,
              name: employee.person ? employee.person.name : 'No Person',
              placeOfBirth: employee.person ? employee.person.dob_state_lookup_uid : '',
              // title: '',
              position: '',
              totalReports: 0,
              link: '#/orgchart/' + employee.employee_uid,
            },
            report_to: employee.report_to,
          }

          toAdd.person.position = 'No Position'
          if (employee.current_position && employee.current_position.position) {
            toAdd.person.position = employee.current_position.position.name
          }

          temp.push(toAdd)
        })
        return temp.sort((a, b) => {
          if (a.departmentId === b.departmentId) {
            return a.name > b.name ? 1 : -1
          }
          return a.departmentId < b.departmentId ? 1 : -1
        })
        // return temp
      },
      flatToHierarchy (flat) {
        var roots = [] // things without parent

        // make them accessible by guid on this map
        var all = {}
        flat.forEach(function (item) {
          all[item.employee_uid] = item
          all[item.employee_uid].children = []
        })
        // connect childrens to its parent, and split roots apart
        Object.keys(all).forEach(function (uid) {
          var item = all[uid]
          if (item.report_to === null) {
            roots.push(item)
          } else {
            let found = false
            for (var key in all) {
              if (key === item.report_to.assigned_to) {
                found = true
              }
            }
        
            if (found === true) {
              var p = all[item.report_to.assigned_to]
              p.children.push(item)
          
              p.person.totalReports += 1
            }
          }
        })
    
        roots = roots.filter((employee) => {
          return (employee.children.length > 0 || (employee.children.length === 0 && employee.report_to !== null)) 
        })
    
        return roots.sort((a, b) => {
          return a.children.length < b.children.length ? 1 : -1 
        })
      },
      searchEmployeeInChart (employeeUid) {
        if (employeeUid) {
          searchEmployee(employeeUid)
        }
      },
    },
  }
</script>

<style lang='css'>
  /* html, body {
    margin: 0;
    height: 100%;
    width: 100%;
    font-size: 12px;
    font-family: "SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
  }*/
  #root {
    /* margin: 0; */
    cursor: move;
    /* height: 100%; */
    /* width: 100%; */
    background-color:#f7f9fa;
  } 
  .org-chart-person-name {
    font-weight: 500;
  }
  .org-chart-person-link:hover g {
    fill: #409CF9 !important;
  }
  .org-chart-node:hover .org-chart-person-reports {
    fill: #409CF9 !important;
  }
  .org-chart-person-dept.engineering {
    fill: #4CAF50 !important; 
  }
  .org-chart-person-dept.communications {
    fill: #3F51B5 !important; 
  }
  .org-chart-person-dept.product {
    fill: #D500F9 !important; 
  }
  .org-chart-person-dept.hr {
    fill: #2196F3 !important; 
  }
  .org-chart-person-dept.marketing {
    fill: #F44336 !important; 
  }
  .org-chart-person-dept.design {
    fill: #26C6DA !important; 
  }

  circle {
    fill: none;
    stroke: #000000;
  }
    
  /* .orgchart {
    height:100%;
    width:100%;
    overflow:hidden;
    position: absolute;
  } */

  ::v-deep hr{
    margin-top:8px;
    margin-bottom:8px;    
  }
</style>
